import React from 'react'
import { MetaTags } from '../meta-tags'
import { routes } from '../../routes'

const SearchMetaTags = ({ searchTerm }) => {
  return (
    <MetaTags
      title='Search Results'
      description={`Search results for: ${searchTerm}`}
      canonicalLink={location.origin + routes.serp.path}
      metaTags={[
        { name: 'robots', content: 'noindex' }
      ]}
    />
  )
}

export default SearchMetaTags
